export default __webpack_public_path__ + "static/media/michael.2057573d.jpg";